import React from "react"
import SolidHexagon from "../../../Hexagon/SolidHexagon/SolidHexagon"
import * as styles from './ControlArrows.module.scss'
import { Icon } from '@iconify/react';


const ControlArrows = ({forwardClickHandler, backClickHandler}) => {
    return(  
            <section className={`${styles.controlArrows}` }>
                <button className={`${styles.controlArrows_button}` } onClick={backClickHandler}><SolidHexagon color='lightGrayButton'>
                    <Icon icon="eva:arrow-ios-back-fill" inline={true} width="28" height="28" vAlign='center'/>
                </SolidHexagon></button>
                <button className={`${styles.controlArrows_button}` } onClick={forwardClickHandler}> <SolidHexagon color='lightGrayButton'>
                    <Icon icon="eva:arrow-ios-forward-fill" inline={true} width="28" height="28" vAlign='center'/>
                </SolidHexagon></button>
           </section>          
    )
}

export default ControlArrows